// src/pages/.../PatientMap.jsx
import React, { useContext, useCallback, useEffect } from "react";
import { PatientMapContext } from "../../context/PatientContext/PatientMapContext";
import PatientMapFilters from "./PatientMapComp/Filters/PatientMapFilters";
import PatientMapTabs from "./PatientMapComp/Tabs/PatientMapTabs";
import { Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PatientMap = () => {
  const {
    page, setPage, pageSize, setPageSize,
    memberFullName, setMemberFullName,
    locationId, setLocationId,
    memberType, setMemberType,
    pcpName, setPcpName,
    gender, setGender,
    ageFrom, setAgeFrom,
    ageTo, setAgeTo,
    filterAdmitted, setFilterAdmitted,
    filterDischarged, setFilterDischarged,
    filterEmergency, setFilterEmergency,
    filterHighCost, setFilterHighCost,
    filterHighRisk, setFilterHighRisk,
    fetchData
  } = useContext(PatientMapContext);

  const navigate = useNavigate();

  const handleApply = useCallback(() => {
    setTimeout(() => {
      setPage(0);
      fetchData();
    }, 1000);
  }, [setPage, fetchData]);

  useEffect(() => {
    fetchData();
  }, [page, pageSize]); // eslint-disable-line react-hooks/exhaustive-deps

  // ✅ El ojo manda params.row -> aquí navegamos al detalle
  const handleSelectPatient = useCallback((row) => {
    const cipId = row?.cipId;
    if (!cipId) return;

    // Ajusta esta ruta a la real de tu app:
    // ejemplo: /patient-detail o /profiles/patient-detail etc.
    navigate(`/patient-detail/${cipId}`, {
      state: { patientRow: row }, // ✅ fila completa
    });
  }, [navigate]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Patient Map
      </Typography>

      <PatientMapFilters
        memberFullName={memberFullName} setMemberFullName={setMemberFullName}
        locationId={locationId}         setLocationId={setLocationId}
        memberType={memberType}         setMemberType={setMemberType}
        pcpName={pcpName}               setPcpName={setPcpName}
        gender={gender}                 setGender={setGender}
        ageFrom={ageFrom}               setAgeFrom={setAgeFrom}
        ageTo={ageTo}                   setAgeTo={setAgeTo}
        filterAdmitted={filterAdmitted}             setFilterAdmitted={setFilterAdmitted}
        filterDischarged={filterDischarged}         setFilterDischarged={setFilterDischarged}
        filterEmergency={filterEmergency}           setFilterEmergency={setFilterEmergency}
        filterHighCost={filterHighCost}             setFilterHighCost={setFilterHighCost}
        filterHighRisk={filterHighRisk}             setFilterHighRisk={setFilterHighRisk}
        onApply={handleApply}
      />

      <PatientMapTabs onSelectPatient={handleSelectPatient} />
    </Box>
  );
};

export default PatientMap;
